import { render } from "./OpenCNPJ.vue?vue&type=template&id=7ad8ff02&scoped=true"
import script from "./OpenCNPJ.vue?vue&type=script&lang=js"
export * from "./OpenCNPJ.vue?vue&type=script&lang=js"

import "./OpenCNPJ.vue?vue&type=style&index=0&id=7ad8ff02&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad8ff02"]])

export default __exports__